import { type SurfaceSdkConfig } from '@atlassian/surface-sdk';

import { type Actions } from '../../index';
import { dismiss, showReasons } from '../../utils/ufo';

export const observabilitySideEffects: NonNullable<
	SurfaceSdkConfig<any, Actions>['sideEffects']
>[0] = ({ action }) => {
	try {
		switch (action.type) {
			case 'SHOW_REASONS':
				showReasons.start();
				break;
			case 'DISMISS_START':
				dismiss.start();
				break;
			case 'DISMISS_SUCCESS':
				dismiss.success();
				break;
			case 'DISMISS_FAILURE':
				dismiss.failure();
				break;
			default:
				break;
		}
	} catch (error) {
		// TODO: error handling
	}
};
